// extracted by mini-css-extract-plugin
export var floatLeft = "microImage-module--floatLeft--0394a";
export var floatRight = "microImage-module--floatRight--a2058";
export var imageContainer = "microImage-module--imageContainer--2c849";
export var isInline = "microImage-module--isInline--4bc90";
export var microImage = "microImage-module--microImage--f393e";